export default "__VITE_ASSET__7b88c384__"